import React, { Fragment } from "react";

import Link from "@mui/material/Link";
import Box from "@mui/material/Box";

const ButtonAdd = props => {
  const { disabled, size, label, onClick, sx } = props;

  let textStyle = {};
  let iconStyle = {};

  if (size !== undefined) {
    switch (size) {
      case "small":
        textStyle = {
          fontSize: "12px"
        };
        iconStyle = {
          width: "15px",
          height: "15px",
          fontSize: "13px"
        };
        break;
      default:
        break;
    }
  }

  return (
    <Link
      component="button"
      type="button"
      onClick={disabled ? undefined : onClick}
      sx={{
        display: "flex",
        flexDirection: "row",
        pb: 0.125,
        textDecoration: "none",
        fontSize: "13px",
        fontWeight: "bold",
        color: disabled ? "grey.500" : "button.main",
        cursor: disabled ? "not-allowed" : "pointer",
        ...textStyle,
        ...sx
      }}
    >
      <Box
        component="span"
        sx={{
          display: "flex",
          fontSize: "15px",
          fontStyle: "normal",
          lineHeight: "17px",
          color: "#FFF",
          marginRight: "4px",
          border: "1px solid",
          borderRadius: "50%",
          width: "18px",
          height: "18px",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: disabled ? "grey.500" : "button.main",
          ...iconStyle
        }}
      >
        +
      </Box>
      {label}
    </Link>
  );
};

export default ButtonAdd;
